import type { SVGProps } from "react";
import { memo } from "react";
const ElementalMediaTailor = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
    <defs>
      <linearGradient id="prefix__a" x1="0%" x2="100%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="#C8511B" />
        <stop offset="100%" stopColor="#F90" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="url(#prefix__a)" d="M0 0h80v80H0z" />
      <path
        fill="#FFF"
        d="M19 36h-2v-9c0-.366.199-.703.521-.878l11-6.009.958 1.755L19 27.593zm44 0h-2v-8.407l-10.479-5.727.958-1.755 11 6.011A1 1 0 0 1 63 27zM33.508 62.871l-16-9.044a1 1 0 0 1-.508-.87V43h2v9.373l15.492 8.756zm12.984 0-.984-1.742L61 52.373V43h2v9.957c0 .36-.194.693-.508.87zM35 26.382l5 2.5 5-2.5v-6.764l-5-2.5-5 2.5zm-9.942 8.576 14.944 7.911 14.94-7.911-10.44-6.091L41 30.618V35h-2v-4.382l-3.502-1.751zm-.069 10.972 15.01 8.032 15.012-8.032-7.55-4.748L41 44.603 41.001 47h-2L39 44.601l-6.461-3.42zM39.001 66 39 55.696l-16.472-8.814a1 1 0 0 1-.06-1.729l8.031-5.052-7.967-4.217a1.001 1.001 0 0 1-.036-1.748l10.886-6.35A1 1 0 0 1 33 27v-8c0-.379.214-.725.553-.895l6-3c.281-.14.613-.14.894 0l6 3c.339.17.553.516.553.895v8a1 1 0 0 1-.382.786l10.886 6.35a1.002 1.002 0 0 1-.036 1.748l-7.967 4.218 8.031 5.051a1 1 0 0 1-.06 1.729L41 55.695 41.001 66z"
      />
    </g>
  </svg>
);
const Memo = memo(ElementalMediaTailor);
export default Memo;
